import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-white dark:bg-dark-900 flex items-center justify-center z-50">
      <div className="text-center">
        {/* Logo Animation */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <div className="w-20 h-20 rounded-xl overflow-hidden shadow-lg mx-auto">
            <svg width="80" height="80" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
              <defs>
                <linearGradient id="loadingLogoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor:"#3B82F6", stopOpacity:1}} />
                  <stop offset="50%" style={{stopColor:"#1D4ED8", stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:"#1E40AF", stopOpacity:1}} />
                </linearGradient>
                <linearGradient id="loadingAccentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor:"#10B981", stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:"#059669", stopOpacity:1}} />
                </linearGradient>
              </defs>
              
              {/* Background Circle */}
              <circle cx="24" cy="24" r="22" fill="url(#loadingLogoGradient)" stroke="#1E40AF" strokeWidth="1.5"/>
              
              {/* Letter M */}
              <path d="M14 16 L14 32 L16.5 32 L16.5 22 L19 26 L21.5 22 L21.5 32 L24 32 L24 16 L21.5 16 L19 20 L16.5 16 L14 16 Z" fill="white"/>
              
              {/* Letter N */}
              <path d="M26 16 L26 32 L28.5 32 L28.5 22 L31.5 32 L34 32 L34 16 L31.5 16 L28.5 26 L28.5 16 L26 16 Z" fill="white"/>
              
              {/* Tech accent - Code brackets */}
              <path d="M8 12 L6 12 L6 10 L8 10 L8 12 Z M8 14 L6 14 L6 16 L8 16 L8 14 Z" fill="url(#loadingAccentGradient)"/>
              <path d="M40 10 L42 10 L42 12 L40 12 L40 10 Z M40 16 L42 16 L42 14 L40 14 L40 16 Z" fill="url(#loadingAccentGradient)"/>
              
              {/* Small dot accent */}
              <circle cx="38" cy="38" r="1.5" fill="url(#loadingAccentGradient)"/>
            </svg>
          </div>
        </motion.div>

        {/* Loading Text */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-2xl font-display font-bold text-gray-900 dark:text-white mb-4"
        >
          Matthew Newman
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-lg text-gray-600 dark:text-gray-300 mb-8"
        >
          Full Stack Developer
        </motion.p>

        {/* Loading Animation */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex justify-center space-x-2"
        >
          <motion.div
            className="w-3 h-3 bg-primary-600 rounded-full"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: 0,
            }}
          />
          <motion.div
            className="w-3 h-3 bg-primary-600 rounded-full"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: 0.2,
            }}
          />
          <motion.div
            className="w-3 h-3 bg-primary-600 rounded-full"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: 0.4,
            }}
          />
        </motion.div>

        {/* Progress Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-8 w-64 mx-auto"
        >
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
            <motion.div
              className="bg-gradient-to-r from-primary-500 to-primary-600 h-2 rounded-full"
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ duration: 2, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingScreen;
